import { styled } from 'styled-components';
import { breakpoints } from '@/config/breakpoints';
import IntroBg from '@/assets/images/home/intro-bg.png';
import IntroMobileBg from '@/assets/images/home/intro-bg-mobile.png';
import { Carousel } from 'antd';
import { ContentWrapper, KeyText } from '../../style';

export const Wrapper = styled.div`
  width: 100%;
  background-image: url(${IntroBg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  @media screen and (max-width: ${breakpoints.md}) {
    background-image: url(${IntroMobileBg});
  }
`;

export const CarouselWrapper = styled(Carousel)`
  .slick-dots {
    bottom: 25px;
    li {
      width: max-content !important;
      button {
        width: 10px !important;
        height: 10px !important;
        border-radius: 100px !important;
      }
    }
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  color: white;
  overflow: hidden;
  align-items: center;
  position: relative;
  width: 100%;
  height: auto;
  /* padding: 0px 40px 172px; */
  padding: 50px 24px 50px;
  max-width: 1176px;
  margin: 0 auto;
  @media screen and (max-width: ${breakpoints.lg}) {
    background-image: none;
    padding: 52px 16px;
    align-items: center;
  }
  @media screen and (max-width: ${breakpoints.md}) {
    flex-direction: column;
    gap: 60px;
  }
`;

export const FrameContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 50%;
  z-index: 99;
  justify-content: flex-end;
  gap: 40px;
  @media screen and (max-width: ${breakpoints.lg}) {
    width: 40%;
  }
  @media screen and (max-width: ${breakpoints.md}) {
    width: 100%;
    justify-content: center;
    align-items: center;
  }
`;

export const HeaderTitle = styled.span`
  font-size: 40px;
  line-height: 48px;
  margin-top: 12px;
  font-family: 'GTWalsheimPro';
  font-weight: 700;
  @media screen and (max-width: ${breakpoints.lg}) {
    font-size: 24px;
    line-height: 32px;
  }
  @media screen and (max-width: ${breakpoints.md}) {
    text-align: center;
  }
  @media screen and (max-width: ${breakpoints.sm}) {
    text-align: center;
    margin-top: 1.5rem;
    font-size: 28px;
    line-height: 36px;
  }
`;

export const HeaderImg = styled.img`
  position: absolute;
  top: 0px;
  right: 60px;
  @media screen and (max-width: ${breakpoints.md}) {
    top: 400px;
    right: 0;
    height: auto;
    width: 100%;
  }
`;

export const FrameImageRight = styled.div`
  display: flex;
  flex: 1;
  width: 50%;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: ${breakpoints.lg}) {
    width: 60%;
  }
  @media screen and (max-width: ${breakpoints.md}) {
    margin-top: 40px;
    width: 100%;
    margin: 0;
  }
`;

export const ComputerImg = styled.img`
  width: 100%;
  margin-right: 0;
  max-width: 413px;
  @media screen and (max-width: ${breakpoints.lg}) {
    width: 100%;
    // max-width: 213.705px;
    height: auto;
    object-fit: contain;
  }
  @media screen and (max-width: ${breakpoints.md}) {
    width: 100%;
  }
`;

export const BodyButton = styled.div`
  padding: 8px 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  p {
    margin: 0px;
    color: var(--status-white, #fff);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    padding: 8px 0;
  }
`;

// export const ButtonAllTool = styled.div`
//   display: flex;
//   height: 48px;
//   padding: 11px 24px;
//   justify-content: center;
//   align-items: center;
//   /* margin-top: 32px; */
//   border-radius: 8px;
//   border-width: 0px;
//   min-width: 162px;
//   width: max-content;
//   color: white;
//   background: var(--linear, linear-gradient(217deg, #e250e5 0%, #4b50e6 100%));
//   box-shadow: 0px 4px 24px 0px rgba(81, 66, 252, 0.22);
//   cursor: pointer;
//   font-weight: 600;
//   @media screen and (max-width: ${breakpoints.md}) {
//     width: 100%;
//   }
// `;

export const ButtonTryFree = styled.div<{ disabled?: boolean }>`
  display: flex;
  /* height: 40px; */
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  /* margin-top: 12px; */
  width: max-content;
  border-radius: 4px;
  border-width: none;
  background: var(--linear, linear-gradient(217deg, #e250e5 0%, #4b50e6 100%));
  box-shadow: 0px 4px 24px 0px rgba(81, 66, 252, 0.22);
  cursor: pointer;
  font-weight: 600;
  min-width: 100px;
  width: max-content;
  gap: 8px;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    filter: ${(props) =>
      props.disabled ? 'brightness(1)' : 'brightness(0.8)'};
  }
  img {
    height: 16px;
  }
  p {
    margin: 0px;
    color: var(--neutral-0, #fff);
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
  }
`;

export const ButtonWrapper = styled.div`
  width: auto;
  @media screen and (max-width: ${breakpoints.md}) {
    /* width: 100%; */
    align-self: flex-start;
  }
`;

export const CustomContentWrapper = styled(ContentWrapper)`
  gap: 12px;
`;

export const CustomKeytext = styled(KeyText)`
  font-size: 16px;
  margin-bottom: 0px;
`;

export const FrameRight = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ToolImg = styled.img`
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 520px;
  &.img-discount {
    position: relative;
    bottom: 50px;
  }
`;

export const ToolBg = styled.img`
  position: absolute;
  top: 20px;
  left: -30px;
  max-width: 100%;
  @media screen and (max-width: ${breakpoints.md}) {
    top: 0;
    left: 0;
  }
`;

export const DiscountImg = styled.img`
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 433px;
`;

export const DiscountCoins = styled.img`
  position: absolute;
  z-index: 3;
  top: 0;
  max-width: 100%;
  @media screen and (max-width: ${breakpoints.md}) {
    top: 0;
    left: 0;
  }
`;

export const DiscountShadow = styled.div`
  /* fill: rgba(252, 241, 184, 0.35); */
  position: absolute;
  /* z-index: 4px; */
  background-color: rgba(252, 241, 184, 0.35);
  filter: blur(62px);
  width: 115px;
  height: 114px;
  flex-shrink: 0;
`;

export const ToolShadow = styled.div`
  /* fill: rgba(252, 241, 184, 0.35); */
  position: absolute;
  /* z-index: 4px; */
  background-color: rgba(173, 99, 254, 0.45);
  filter: blur(61px);
  width: 201px;
  height: 201px;
  flex-shrink: 0;
  border-radius: 100px;
  opacity: 0.5;
`;
